var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogo2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X_logo_2023.svg",
    clipPath: "url(#clip0_574_3609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.24639 6.28658L13.3788 0.404541H12.1677L7.66972 5.47924L4.15203 0.404541H0L5.4207 8.07426L0 14.2446H1.21101L5.93971 8.8816L9.74573 14.2446H13.8401L8.24639 6.28658ZM1.67234 1.32721H3.51769L12.1101 13.3796H10.2647L1.67234 1.32721Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_574_3609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8401,
    height: 13.8401,
    fill: "white",
    transform: "translate(0 0.404541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo2023);
export default __webpack_public_path__ + "static/media/X_logo_2023.7ba643149da8bcba67fc8fc894b3cd26.svg";
export { ForwardRef as ReactComponent };